/**
 * The bottom limit of percentage.
 * @type {Number}
 */
export const MIN_PERCENT = 0;

/**
 * The upper limit of percentage.
 * @type {Number}
 */
export const MAX_PERCENT = 100;

/**
 * Gets a "safe" percent for progressbars.
 * @param  {Number} percent The progress percent.
 * @return {Number}
 */
export const getProgressPercent = (percent) => {
    if (isNaN(percent) || percent <= MIN_PERCENT) {
        return MIN_PERCENT;
    }

    if (percent >= MAX_PERCENT) {
        return MAX_PERCENT;
    }

    return percent;
};
